module.exports = __webpack_public_path__ + "static/media/firstfloor.886e7e54.png";